import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IOffer } from "@/data/model/Offer";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { ArticleOverview } from "@/portal/elements/ArticleOverview";
import { OfferForm } from "@/portal/forms/OfferForm";
import { TastierGlobal } from "@/portal/globalAccess";
import {UiNotification} from "@/portal/ui/Notification";
import {i18n} from "@/portal/Trans";

export class OfferController extends BaseTabbedController<IOffer> {
    private offerForm: OfferForm;
    private articleOverview?: ArticleOverview;

    constructor(element: JQuery) {
        super(element, Factory.getInstance<CatalogDao>(CatalogDao).offerDataSource);

        this.offerForm = new OfferForm(this.formContentByTabName("offeredit"));
        this.registerModelForm(this.offerForm);

        this.onActivateTab = (newTab) => {
            if (newTab === "articles") this.showArticles();
        };
    }

    protected onModelLoaded(m?: IOffer) {
        
        if (this.copyEntityId != null) {
            UiNotification.showSuccess(i18n("offer.offerCopiedAndEditingNow"))
        }
        
        if (m === undefined) {
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );

            this.disableTabs(["articles"]);
        } else {
            if (this.copyEntityId != null) {
                this.activateTab("offeredit");
            } else {
                this.enableTabs(["articles"]);
                this.activateTab("articles");
            }
       
        }

        this.offerForm.setData(m, this.copyEntityId);
        
       
    }

    private showArticles() {
        if (this.articleOverview === undefined) {
            if (this.copyEntityId != null) {
                this.articleOverview = new ArticleOverview(this.copyEntityId).appendTo(
                  //  this.formContentByTabName("articles").find("> .article-overview-container.row > .col-lg-9")
                    this.formContentByTabName("articles").find("> .article-overview")
                );
            } else {
                this.articleOverview = new ArticleOverview(this.model!.id).appendTo(
                    this.formContentByTabName("articles").find("> .article-overview")
                );
            }
        }
    }
}
